<template>
    <div class='footer'>
        四川省人民政府口岸与物流办公室 Copyright2018 All Rights Reserve &nbsp;<a style = "color:#939cb1;font-size: 16px;" href="https://beian.miit.gov.cn/" target="_blank">备案号：蜀ICP备12000086号-9</a>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    mounted() {},

    methods: {}
};
</script>

<style lang='less'>
    .footer {
        background: #0b2154;
        color: #939cb1;
        font-size: 16px;
        padding: 20px 0;
        text-align: center;
    }
</style>
